
import { motion } from "framer-motion";
import { FlaskConical } from "lucide-react";
import { RecipeCard } from "../RecipeCard";
import { Card } from "../ui/card";

interface ScienceCard {
  title: string;
  explanation: string;
  experiment?: string;
}

interface ScienceCardsProps {
  cards: ScienceCard[];
}

export const ScienceCards = ({ cards }: ScienceCardsProps) => {
  if (!cards.length) return null;

  return (
    <RecipeCard title="Kitchen Science" icon="🧪">
      <div className="grid gap-4 sm:grid-cols-2">
        {cards.map((card, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.1 }}
          >
            <Card className="p-4 h-full bg-gradient-to-br from-purple-50 to-blue-50 hover:shadow-lg transition-shadow duration-200">
              <div className="space-y-3">
                <div className="flex items-center gap-2">
                  <FlaskConical className="h-5 w-5 text-purple-500" />
                  <h3 className="font-medium text-purple-700">{card.title}</h3>
                </div>
                <p className="text-sm text-gray-600">{card.explanation}</p>
                {card.experiment && (
                  <div className="mt-3 p-3 bg-white/80 rounded-md">
                    <p className="text-sm font-medium text-emerald-600">Try This! 🔬</p>
                    <p className="text-sm text-gray-600 mt-1">{card.experiment}</p>
                  </div>
                )}
              </div>
            </Card>
          </motion.div>
        ))}
      </div>
    </RecipeCard>
  );
};
